export type TriggerType = 'click' | 'page_visit' | 'transaction' | 'event';

export class Goal {
  public id: string;
  public title: string;
  public type: TriggerType;
  public isMainGoal: boolean;

  constructor({ id, title, type, isMainGoal }: { id: string; title: string; type: TriggerType; isMainGoal: boolean }) {
    this.id = id;
    this.title = title;
    this.type = type;
    this.isMainGoal = isMainGoal;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/domain/entity/Goal.ts